// All copy is the user's own website content (kameljaber.com).
import kamelPhoto from "../assets/kamel.webp";

export const portrait = kamelPhoto;

export const hero = {
  title: "well-being to well-doing",
  roles: "co-founder har-monic. founder zenish gardens. mentor, writer & speaker.",
  stats: ["$300M+ MANAGED", "250+ EMPLOYEES", "3 CONTINENTS", "100+ MENTORED"],
};

export const philosophy = {
  headline: "feeling well is the beginning.",
  emphasis: "i help you figure out what you do with it.",
  paragraphs: [
    "Most of what is offered under the banner of well-being treats feeling better as the destination. Years of practice taught me it is the starting line.",
    "The truth is – you will never totally be done. I'm not. But there comes a point where the inner work stops being only about you, and a harder question comes up: what are you going to do now? Waiting for some non-existent finish line before you ask is why most people still don't feel good after years of trying everything.",
    "We are hard-wired as tribal beings – contributing to the collective is the unspoken yet essential component of wellness.",
  ],
  closing: "That is the move from well-being to well-doing.",
};

export const video = {
  id: "9vHsw6xTn9M",
  caption: "Ink in Water",
};

export const story = [
  "I spent twenty years in investment management and real estate development across London and the Middle East — $300m and more under management, managing hundreds of people across three continents.",
  "I built a manufacturing business in the desert, delivered residential schemes in central London, and ran an investment company through periods of political unrest. I was the person people called when something was actually on fire, and I was very good at it.",
  "I was also running on untreated PTSD and calling it resilience. It caught up with me in my thirties.",
  "What followed was years of experimenting with various kinds of practices, and a long unflattering look at patterns I hadn't known I was running. It also took me to India, Nepal and Peru, living in and studying wisdom traditions, trying to understand what actually makes communities thrive.",
  "I learned to be where I am. Then people started asking me to teach. Since 2019 I have privately mentored more than a hundred people and run teaching residencies across Europe and the United States, including for organisations like Soho House — meditation, yoga philosophy, somatic awareness, and hypnosis techniques I had studied extensively.",
  "I had assumed the answer was a quiet, contemplative life away from the hustle. It wasn't. We are at the start of the largest shift most of us will live through — new technology arriving faster than we can absorb it, politics pulling people apart, the natural world in disorder.",
  "It was difficult to look at my own life — the strategy, the crisis management, the years of practice — and not conclude that all of it had been training for this moment in time. I was not going to sit this out.",
  "And I help others do the same - make their mission in life happen.",
];

export const building = [
  {
    name: "har-monic",
    text: "A regenerative property development company, working with local visionaries to revive forgotten buildings. We establish vibrant places for living, gathering and the creative enterprises.",
  },
  {
    name: "zenish",
    text: "A charity farm in East London, with a mission to feed thousands in need. All crops are donated to local food banks and distribution centres. Community and education programmes run in tandem on site.",
  },
  {
    name: "onwards",
    text: "My personal platform for mentoring, speaking and writing. Where the tools and lessons of ancient practices serve as the foundation for innovation, entrepreneurship and community.",
  },
];

export const work = [
  {
    title: "Mentorship",
    tagline: "ONE TO ONE, OVER TIME",
    paragraphs: [
      "The deep version. We work holistically — what you are building, how you are building it, how you feel, and what you need to move forward.",
      "I have mentored more than a hundred people since 2019. I take on only a small number at a time.",
      "Three-month commitment, meeting twice a month, with support in between.",
    ],
  },
  {
    title: "Onwards",
    tagline: "A GROUP FOR PEOPLE ALREADY BUILDING",
    paragraphs: [
      "You do not need to be healed. What you do need is to have started — with enough work behind you to know what that work is, and enough distance from it to have an idea of your \u201cwhy\u201d.",
      "Healing will happen here. It just isn't the reason we meet. We meet because everyone is an agent of change, building something, and building is easier in community.",
      "We vibe off each other, learn from each other and empower each other to be the best we can be. I provide facilitation on everything from structuring and finances, to clarity practices.",
      "Two intakes a year. Limited group size. By application.",
    ],
  },
  {
    title: "Consulting",
    tagline: "DEEP WORK",
    paragraphs: [
      "For founders, family offices and organisations who need systemic help. Using my knowledge and contacts, I have assisted companies ranging from wellness hotels to tech startups to organic food retail.",
    ],
    points: [
      { n: "01", text: "Strategy, direction and branding — Where the thing is actually going, and how you can get it there." },
      { n: "02", text: "Financial planning — Capital structures, models, budgets." },
      { n: "03", text: "Partnerships — Figuring out who the right people are to expand your potential, on the right terms." },
      { n: "04", text: "Curation of transformational experiences — Rooms, gatherings and journeys built to change people. Most of what I know about how people actually change, I learned building these." },
    ],
  },
];

export const contactEmail = "hello@kameljaber.com";
export const substackUrl = "https://kameljaber.substack.com";
export const social = [
  { label: "Instagram", href: "https://www.instagram.com/i__kamel/" },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/kamel-jaber/" },
];
